import _ from 'lodash';
import { CONSTANT } from '../utils/constant';

const {
    KEYS: {
        CHANNELS: { DEALER, CSD, NBD, ADT, HEALTH, BCX_CARE, CORP_STORE },
        ROLES: {
            ADMIN,
            SALES_REP,
            ORDER_FULFILLMENT,
            PROPOSAL_HOUSE,
            SALES_MANAGER,
            SALES_SUPPORT
        }
    }
} = CONSTANT;

const baseFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'salesManager',
    'salesManagerEmail'
];

const adminFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'xid',
    'salesManager',
    'salesManagerEmail'
];

const salesRepFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'channelId',
    'outlet',
    'cpmsId',
    'salesManager',
    'salesManagerEmail'
];

const salesRepDealerFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'channelId',
    'dealership',
    'channelOrgCode',
    'outlet',
    'cpmsId',
    'salesManager',
    'salesManagerEmail'
];

const salesRepCorpStoreFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'channelId',
    'storeCode',
    'xid',
    'outlet',
    'cpmsId',
    'salesManager',
    'salesManagerEmail'
];

const salesRepXidFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'channelId',
    'xid',
    'salesManager',
    'salesManagerEmail'
];

const salesManagerFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'channelId',
    'outlet',
    'cpmsId',
    'salesManager',
    'salesManagerEmail'
];

const salesManagerDealerFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'channelId',
    'dealership',
    'channelOrgCode',
    'outlet',
    'cpmsId',
    'requiresOrderAccess',
    'dealershipVisibilityEnabled',
    'salesManager',
    'salesManagerEmail'
];

const salesManagerCorpStoreFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'channelId',
    'storeCode',
    'xid',
    'outlet',
    'cpmsId',
    'salesManager',
    'salesManagerEmail'
];

const salesManagerXidFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'channelId',
    'xid',
    'salesManager',
    'salesManagerEmail'
];

const orderFulfillmentFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'xid',
    'salesManager',
    'salesManagerEmail'
];

const proposalHouseFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'province',
    'contactNumber',
    'xid',
    'salesManager',
    'salesManagerEmail'
];

const salesSupportFields = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'provinceIds',
    'contactNumber',
    'channelIds',
    'xid',
    'salesManager',
    'salesManagerEmail'
];

const salesSupportForCorpStore = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'provinceIds',
    'contactNumber',
    'channelIds',
    'storeCode',
    'xid',
    'outlet',
    'cpmsId',
    'salesManager',
    'salesManagerEmail'
];

const salesSupportForDealer = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'provinceIds',
    'contactNumber',
    'channelIds',
    'xid',
    'salesManager',
    'salesManagerEmail'
];

const salesSupportForCorpStoreAndDealer = [
    'roleId',
    'firstName',
    'lastName',
    'email',
    'provinceIds',
    'contactNumber',
    'channelIds',
    'storeCode',
    'xid',
    'salesManager',
    'salesManagerEmail'
];

const checkFieldToDisplay = (role, value) => {
    const valueChannel =
        role === SALES_SUPPORT
            ? _.get(value, 'channelIds', [])
            : _.get(value, 'channelId.0.id', '');

    switch (role) {
        case ADMIN:
            return adminFields;
        case SALES_REP:
            if ([CSD, NBD, ADT, HEALTH, BCX_CARE].includes(valueChannel))
                return salesRepXidFields;
            if (valueChannel === DEALER) return salesRepDealerFields;
            if (valueChannel === CORP_STORE) return salesRepCorpStoreFields;
            return salesRepFields;
        case ORDER_FULFILLMENT:
            return orderFulfillmentFields;
        case PROPOSAL_HOUSE:
            return proposalHouseFields;
        case SALES_MANAGER:
            if ([CSD, NBD, ADT, HEALTH, BCX_CARE].includes(valueChannel))
                return salesManagerXidFields;
            if (valueChannel === DEALER) return salesManagerDealerFields;
            if (valueChannel === CORP_STORE) return salesManagerCorpStoreFields;
            return salesManagerFields;
        case SALES_SUPPORT:
            if (valueChannel.includes(DEALER) && !valueChannel.includes(CORP_STORE))
                return salesSupportForDealer;
            if (!valueChannel.includes(DEALER) && valueChannel.includes(CORP_STORE))
                return salesSupportForCorpStore;
            if (valueChannel.includes(DEALER) && valueChannel.includes(CORP_STORE))
                return salesSupportForCorpStoreAndDealer;

            return salesSupportFields;
        default:
            return baseFields;
    }
};

export default checkFieldToDisplay;
